import React, {Component} from 'react';
import {Steps, message, Icon, Modal, Pagination} from 'antd';
import {Redirect} from 'react-router';
import MerchandiseMix from '../../../components/frontEnd/merchandiseMix/merchandiseMix';
import './orderDetail.less';

const Step = Steps.Step;

function Status(props) {
  const status = props.status;
  let content;
  switch (status) {
    case 0:
      content = <p style={{color: 'orange'}}>等待付款</p>;
      break;
    case 1:
      content = <p>等待发货</p>;
      break;
    case 2:
      content = <p style={{color: 'green'}}>等待收货</p>;
      break;
    case 3:
      content = <p style={{color: 'green'}}>已完成</p>;
      break;
    case 4:
      content = <p style={{color: 'red'}}>已取消</p>;
      break;
    case 5:
      content = <p style={{color: 'red'}}>已退款</p>;
      break;
    default:
      content = null;
      break;
  }
  return content;
}
class OrderDetail extends Component {
  state = {
    order: {}, // 订单详情
    goods: {}, // 商品详情
    step: 0, // 第几步
    time: '', // 剩余时间
    timer: null, // 定时器
    redirect: false,
    type: 'goods', // 订单是商品还是套餐
    visible: false, // 控制弹窗的显示
    currentPage: 1, // 当前页
    total: 0, // 总条目数
    goodsList: [], // 关联商品组合的列表
    sourceCMS: '', // 来源标识
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      const orderNo = this.props.location.state.order_no;
      const sourceCMS = window.localStorage.getItem('sourceCMS') || '';
      this.setState({sourceCMS});
      this.getOrderDetail(orderNo);
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  // 获取订单详情
  getOrderDetail = (orderNo) => {
    window.api('order.orderList', {order_no: orderNo}).then(res => {
      const status = res.orders[0].status;
      let step = status + 1; // 0：等待付款，1：等待发货，2：等待收货，3：已完成，4：已取消，5：已退款（默认0）
      status === 4 ? step = 1 : null;
      status === 5 ? step = 3 : null;
      const detail = res.orders[0].order_details[0];
      const create = status === 0 ? (new Date(detail.gmt_created)).getTime() : (new Date(detail.gmt_created)).getTime();
      let deadline = create + 24 * 60 * 60 * 1000;
      deadline = status === 2 && detail.is_post === 0 ? create + 14 * 24 * 60 * 60 * 1000 : deadline;
      const alltime = deadline - (new Date()).getTime();
      if (alltime > 0 && (status === 0 || status === 2)) { // 超时判断，超过时间重新获取数据
        this.createTimer(alltime, deadline, res.order_no);
      }
      detail.total_amt = (detail.total_amt).toFixed(2);
      detail.real_amt = (detail.real_amt).toFixed(2);
      detail.goods_sale_price = (detail.goods_sale_price).toFixed(2);
      this.setState({
        order: res.orders[0],
        step,
        goods: detail,
        type: Number(detail.goods_type) === 1 ? 'goods' : 'setMeal'
      });
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 创建定时器
  createTimer(alltime, deadline, orderNo) {
    let timer = null;
    timer = setInterval(() => {
      alltime = deadline - (new Date()).getTime();
      const day = parseInt(alltime / (24 * 60 * 60 * 1000), 10);
      const time0 = alltime - day * 24 * 60 * 60 * 1000;
      const hours = parseInt(time0 / (60 * 60 * 1000), 10);
      const time1 = time0 - hours * 60 * 60 * 1000;
      const minutes = parseInt(time1 / (1000 * 60), 10);
      const time2 = time1 - minutes * 60 * 1000;
      const seconds = parseInt(time2 / 1000, 10);
      const time = `${day > 0 ? `${day}天` : ''}${hours < 10 ? `0${hours}` : hours}时${minutes < 10 ? `0${minutes}` : minutes}分${seconds < 10 ? `0${seconds}` : seconds}秒`;
      this.setState({time});
      if (alltime === 0) this.getOrderDetail(orderNo);
    }, 1000);
    this.setState({timer});
  }

  // 付款
  pay = () => {
    const {order, goods} = this.state;
    const info = {
      order_no: order.order_no,
      real_amt: order.real_amt,
      total_amt: order.total_amt,
      address: `${order.province} ${order.city} ${order.area} ${order.address}`,
      goods_name: goods.goods_name
    };
    this.props.history.push('/cashier', {info});
  }

  // 确认收货
  confirmReceipt = () => {
    const {goods, order} = this.state;
    const params = {
      order_no: goods.order_no,
      ids: `${goods.id}`,
    };
    window.api('order.confirmReceived', params).then(res => {
      goods.status = 3;
      order.status = 3;
      this.setState({step: 4});
      message.success('确认收货，已完成订单！');
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 再次购买
  again = () => {
    this.props.history.push('/goodsDetail', {id: this.state.goods.goods_id, type: this.state.type});
  }

  // 查看商品组合
  viewMerchandiseMix = () => {
    const {currentPage, goods} = this.state;
    const params = {id: goods.goods_id, package_detail_page_no: currentPage, package_detail_page_num: 5};
    window.api('eps.getgoodspackageinfo', params).then(res => {
      this.setState({visible: true, goodsList: res.goods_package.goods_package_detail_list, total: res.goods_package.goods_package_detail_count});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 关闭弹窗
  handleCancel = () => {
    this.setState({visible: false});
  }

  // 变更页码
  changePage = async (page) => {
    await this.setState({currentPage: Number(page)});
    this.viewMerchandiseMix();
  }

  // 跳转到详情页
  toDetail = (id) => {
    this.props.history.push('/goodsDetail', {id, type: 'goods'});
  }

  render() {
    const {
      order, goods, step, time, redirect, type, visible, currentPage, total, goodsList, sourceCMS
    } = this.state;
    const hasReceiverInfo = Boolean(order.receiver || order.address || order.mobile);
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="orderDetail">
        <Modal
          width="850px"
          title="查看商品组合"
          visible={visible}
          footer={null}
          onCancel={this.handleCancel}
          className="modal"
        >
          <MerchandiseMix goodsList={goodsList} toDetail={this.toDetail} />
          <Pagination
            className="pagination"
            style={{display: 'flex', justifyContent: 'flex-end'}}
            showQuickJumper
            showSizeChange
            current={currentPage}
            defaultCurrent={1}
            defaultPageSize={5}
            total={Number(total)}
            onChange={this.changePage}
          />
        </Modal>
        <header>
          <div className="order">
            <p>订单号：<span>{order.order_no}</span></p>
            <Status status={order.status} />
            <p style={{display: [1, 3, 4, 5].includes(order.status) ? 'none' : 'block'}}>剩余：{time}</p>
            <button hidden={order.status !== 0} onClick={this.pay}>付款</button>
          </div>
          <div className="progress">
            {order.status === 4 ? (<Steps current={step}>
              <Step title="提交申请" description="" />
              <Step title="完成" description="" />
            </Steps>) : (<Steps current={step}>
              <Step title="提交订单" description="" />
              <Step title="支付成功" description="" />

              {/* 来源标识为1时，不显示正在发货和确认收货 */}
              {order.status === 5 && <Step title={<span style={{color: 'red'}}>已退款</span>} description="" />}
              {order.status !== 5 && sourceCMS !== '1' && <Step title="正在发货" description="" />}
              {order.status !== 5 && sourceCMS !== '1' && <Step title="确认收货" description="" />}
            </Steps>)}
          </div>
        </header>
        <section>
          {/* 来源标识为1时，不显示收货人信息 */}
          {
            sourceCMS !== '1' && hasReceiverInfo &&
            <div>
              <h3><Icon type="home" />收货人信息</h3>
              <div>
                <i>收货人：</i>
                <span>{order.receiver}</span>
              </div>
              <div>
                <i>地址：</i>
                <span className="address">{order.province} {order.city} {order.area} {order.address}</span>
              </div>
              <div>
                <i>手机号码：</i>
                <span>{order.mobile}</span>
              </div>
            </div>
          }
          {order.status === 1 || order.status === 2 || order.status === 3 ? (<div>
            <h3><Icon type="file-text" />订单信息</h3>
            <div>
              <i>付款方式：</i>
              {order.pay_type === 1 && <span>返佣账户</span>}
              {order.pay_type === 2 && <span>充值账户</span>}
              {order.pay_type === 3 && <span>在线支付</span>}
            </div>
            <div>
              <i>付款时间：</i>
              <span>{order.gmt_cashed}</span>
            </div>
            <div>
              <i>商品总额：</i>
              <span>￥{goods.total_amt}</span>
            </div>
          </div>) : null}

          {/* 来源标识为1时，不显示配送信息 */}
          { sourceCMS !== '1' && (order.status === 2 || order.status === 3) ? (<div>
            <h3>配送信息</h3>
            <div>
              <i>快递名称：</i>
              <span>{goods.express_name}</span>
            </div>
            <div>
              <i>快递单号：</i>
              <span>{goods.express_no}</span>
            </div>
          </div>) : null}
        </section>
        <footer>
          <ul className="status">
            <li style={{width: '450px'}}>商品名称</li>
            <li style={{width: '200px'}}>商品编号</li>
            <li style={{width: '120px'}}>单价</li>
            <li style={{width: '120px'}}>数量</li>
            <li style={{width: '120px'}}>操作</li>
          </ul>
          <div className="content">
            <div style={{width: '450px', cursor: 'pointer'}} className="info" onClick={this.again}>
              <img src={goods.goods_pic} />
              <p>{goods.goods_name}</p>
            </div>
            <p style={{width: '200px'}}>{goods.goods_bar_no}</p>
            <p style={{width: '120px'}}>￥{goods.goods_sale_price}</p>
            <p style={{width: '120px'}}>{goods.goods_qty}</p>
            <div className="operation">
              {type === 'setMeal' ? <button className="operation" onClick={this.viewMerchandiseMix}>查看商品组合</button> : null}
              {goods.status === 2 ? <button className="operation" onClick={this.confirmReceipt}>确认收货</button> : null}
              {goods.status === 3 ? <button className="operation" onClick={this.again}>再次购买</button> : null}
            </div>
          </div>
          <div className="content2">
            <div className="money">
              <p>商品总额：￥{goods.total_amt}</p>
              <p>运费：￥0.00</p>
              <p style={{color: 'red'}}>应付总额：<span><em>￥</em>{goods.real_amt}</span></p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default OrderDetail;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/orderDetail/orderDetail.jsx